import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonIcon } from '@ionic/angular/standalone';

@Component({
    selector: 'plus-minus',
    templateUrl: './plus-minus.component.html',
    styleUrls: ['./plus-minus.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, IonIcon]
})
export class PlusMinusComponent implements OnInit {
    @Input() min: number = 0;
    @Input() value: any;
    @Output() valueChange: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }

    change(isAdd: boolean) {
        if (isAdd) {
            ++this.value;
            this.publish();
            return;
        }

        if (!isAdd && this.value > this.min) {
            --this.value;
            this.publish();
        }
    }

    publish() {
        this.valueChange.emit(this.value);
    }
}
